import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import axios from "../../services/axios";
import { useNavigate } from "react-router";
import useAuth from "../../hooks/useAuth";
import { getHoursBetweenDates } from "../../utils/functions";

import Header, {
  NoHeaderScroll,
  HomeHeaderLeft,
} from "../../components/navigation/header";

import KamaListCard from "../../components/kamasutra/listCard";
import KamaListModal from "../../components/kamasutra/modalDescription";
import KamaListUnlock from "../../components/kamasutra/modalUnlock";
import Spinner from "../../components/utils/spinner";

const LIMIT = 15;
const SCROLL_THRESHOLD = 50;

export default function KamasutraCards() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [kamasutra, setKamasutra] = useState([]);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [finished, setFinished] = useState(false);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      fetchData();
      return;
    }
  }, []);

  const fetchData = () => {
    if (finished) {
      return;
    }
    setLoading(true);
    axios
      .get(`/kamasutra?limit=${LIMIT}&offset=${offset}`)
      .then((response) => {
        if (response.data.length === 0) {
          setFinished(true);
          return;
        }
        setKamasutra((prev) => [...prev, ...response.data]);
        setOffset(offset + LIMIT);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleScroll = (e) => {
    const target = e.target;

    if (
      target.scrollHeight - target.scrollTop <=
      target.clientHeight + SCROLL_THRESHOLD
    ) {
      if (!loading) {
        fetchData();
      }
    }
  };

  const handleClick = () => {
    navigate("/kamasutra/themes");
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={HomeHeaderLeft} HeaderCenter={() => {}} />
      <NoHeaderScroll onScroll={handleScroll} className="ps-5 pe-5">
        <h2 className="text-3xl font-bold mb-2">Kama 365</h2>
        <p className="text-base leading-5">{t("kamaExplain")}</p>
        <div className="grid grid-cols-3 gap-3 mt-5">
          {kamasutra.map((value, index) => {
            let unlocked = 0;
            let today = new Date();
            let lastUnlock = new Date();
            lastUnlock.setDate(today.getDate() - 1);

            let unlockedAmount = user?.kama_unlocked_amount || 0;

            if (user?.kama_last_unlock) {
              lastUnlock = new Date(user?.kama_last_unlock);
            }
            const diff = getHoursBetweenDates(today, lastUnlock);

            if (index === unlockedAmount + 1 && diff >= 24) {
              unlocked = 1;
            }

            if (index <= unlockedAmount) {
              unlocked = 2;
            }

            if (user?.isPremium) {
              unlocked = 2;
            }

            return (
              <KamaListCard
                key={`${index}`}
                number={index + 1}
                unlocked={unlocked}
                item={value}
              />
            );
          })}
        </div>
        <div className={`flex justify-center mt-5 ${loading ? "" : "hidden"}`}>
          <Spinner size={7} />
        </div>
        <div className="h-36"></div>
      </NoHeaderScroll>
      <div className="absolute bottom-0 left-0 w-full">
        <div className="bg-[linear-gradient(0deg,#262931,transparent)] h-5"></div>
        <div className="bg-[#262931] p-5">
          <button
            type="button"
            onClick={handleClick}
            className="btn btn-brand rounded text-xl w-full p-2"
          >
            {t("play")} Kama 365
          </button>
        </div>
      </div>
      <KamaListModal />
      <KamaListUnlock />
    </div>
  );
}
